import React from 'react';
import ReactDOM from 'react-dom';
import './core/index.css';
import './core/global.css';
import { BrowserRouter } from 'react-router-dom';
import App from './core/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
